
import { Component, ChangeDetectorRef, OnInit, ViewChild, AfterViewInit, effect, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '../../core/services/snackbar.service';
import { TripSearchService, SearchRequest } from '../../core/services/trip-search.service';
import { DateUtilityService } from '../../core/services/date-utility.service';
import { VehicleModel } from '../../core/interfaces/vehicle-model.interface';
import { Subject, takeUntil } from 'rxjs';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { TripSearchForm } from '../../shared/trip-search-form/trip-search-form.component';
import { TripTypeTabs } from '../../shared/trip-type-tabs/trip-type-tabs.component';
import { MatSelectChange } from '@angular/material/select';
import moment from 'moment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { NavigationTabs } from '../../shared/navigation-tabs/navigation-tabs';
import { AuthService } from '../../core/services/auth.service';
import { LoginRegisterForm } from '../../shared/login-register-form/login-register-form';
import { de } from 'date-fns/locale';

interface BookingPackage {
  image: string;
  name: string;
  packageLabel: string;
  seating: number;
  basicKms: number;
  basicHrs: number;
  extraPerKm: number;
  extraPerHr: number;
  amount: number;
}

// Custom tooltip configuration
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  touchGestures: 'auto',
  position: 'above'
};

@Component({
  selector: 'app-booking-search',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    NgxMaterialTimepickerModule,
    MatTooltipModule,
    TripSearchForm,
    TripTypeTabs,
    NavigationTabs,
    LoginRegisterForm
  ],
  templateUrl: './booking-search.html',
  styleUrl: './booking-search.scss',
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }
  ]
})
export class BookingSearchComponent implements OnInit, AfterViewInit {
  @ViewChild('tripSearchForm') tripSearchFormComponent!: TripSearchForm;


  tripType: 'outstation' | 'local' | 'airport' = 'local';
  //public filterUrl: string;
  packages: any[] = [];
  searchFormData: any = null;
  searchVehicleData: any = null;

  // Estimate Total Modal properties
  showEstimateModal = false;
  selectedPackage: any = null;

  // Login Modal properties
  showLoginModal = false;
  pendingBookingPackage: any = null;

  // API integration properties
  private destroy$ = new Subject<void>();
  isLoading = false;
  clientId: number | null = null;
  isSearchListVisible: boolean = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private snackbarService: SnackbarService,
    private tripSearchService: TripSearchService,
    private dateUtilityService: DateUtilityService,
    private ngZone: NgZone,
    private authService: AuthService
  ) {
    //this.filterUrl = '/assets/filter.svg';
    effect(() => {
      const vehicleData = this.tripSearchService.getSearchVehicleData();
      if (vehicleData != null && Array.isArray(vehicleData)) {
        // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.searchVehicleData = vehicleData;
          this.processVehicleData();
        });
      }
    });

    // Listen for search form data changes to handle mobile filter closing
    effect(() => {
      const searchFormData = this.tripSearchService.getSearchFormData();
      if (searchFormData && this.isMobile && this.isVisible) {
        // Close mobile filter after successful search
        setTimeout(() => {
          this.closeMobileFilter();
        }, 500);
      }
    });
  }

  selectedTab = 'local';
  searchTerm: string = '';
  isVisible: boolean = false;
  isMobile: boolean = false;
  isCheckhandshake: boolean = false;
  filteredPackages: any[] = [];

  // Filter packages based on search term
  filterPackages(searchTerm: string) {
    if (!searchTerm.trim()) {
      this.filteredPackages = this.packages;
      return;
    }
    const search = searchTerm.toLowerCase().trim();
    this.filteredPackages = this.packages.filter(pkg =>
      pkg.vehicleName?.toLowerCase().includes(search) ||
      pkg.packageName?.toLowerCase().includes(search) ||
      pkg.vehicleType?.toLowerCase().includes(search) ||
      pkg.seatingCapacity?.toString().includes(search) ||
      pkg.basicKM?.toString().includes(search) ||
      pkg.basicHrs?.toString().includes(search) ||
      pkg.extraPerKm?.toString().includes(search) ||
      pkg.extraHrs?.toString().includes(search) ||
      pkg.parkingIncExc?.toLowerCase().includes(search) ||
      pkg.tollIncExc?.toLowerCase().includes(search)
    );
  }

  form = new FormGroup({
    startDate: new FormControl('', Validators.required),
    selectPackageType: new FormControl(''),
    city: new FormControl('', Validators.required),
    vehicleType: new FormControl('All'),
    pickupTime: new FormControl(''),
    endDate: new FormControl('')
  });

  ngOnInit() {
    // Check for data in the service (this preserves data across navigation)
    debugger;
    const serviceData = this.tripSearchService.getSearchFormData();

    if (serviceData) {
      this.searchFormData = serviceData;

      // Set trip type from stored data if available
      if (serviceData.tripType) {
        this.selectedTripType = serviceData.tripType;
        this.tripType = serviceData.tripType;
      }

      this.processFormData();
    }

    const serviceVehicleData = this.tripSearchService.getSearchVehicleData();
    if (serviceVehicleData != null && Array.isArray(serviceVehicleData)) {
      this.searchVehicleData = serviceVehicleData;
    }

    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe((result: any) => {
        this.isMobile = result.matches;
        // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          if (this.isMobile) {
            this.isVisible = false;
            this.isCheckhandshake = true;
          } else {
            this.isVisible = true;
          }
          this.cdr.detectChanges();
        });
      });

    // Load client details first
    this.GetClientDetails();

    // Test API connectivity
    this.testApiConnectivity();


  }


  private testApiConnectivity(): void {
    // Test client details API
    this.tripSearchService.loadClientDetails().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (clientDetails: any) => {
        // API connectivity test successful
      },
      error: (error: any) => {
        console.error('API connectivity test - Failed to load client details:', error);
        this.snackbarService.openSnackBarError('API connectivity issue detected. Please check your connection.');
      }
    });
  }

  /**
   * Process the received form data for the trip-search-form component
   */
  private processFormData(): void {
    if (this.searchFormData) {
      // Set the selectedTripType from the stored form data
      if (this.searchFormData.tripType) {
        this.selectedTripType = this.searchFormData.tripType;
        this.tripType = this.searchFormData.tripType;
      }

      // Ensure all required fields are present with proper defaults
      this.searchFormData = {
        cityId: this.searchFormData.cityId || '',
        selectPackageType: this.searchFormData.selectPackageType || '',
        vehicleTypeId: this.searchFormData.vehicleTypeId || '',
        startDate: this.searchFormData.startDate || '',
        endDate: this.searchFormData.endDate || '',
        pickupTime: this.searchFormData.pickupTime || '',
        tripType: this.searchFormData.tripType || this.selectedTripType
      };

      // Force change detection to ensure the component updates - use NgZone to prevent ExpressionChangedAfterItHasBeenCheckedError
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.cdr.detectChanges();
          });
        });
      });

      // Manually populate the form if the component is available
      setTimeout(() => {
        this.manuallyPopulateForm();
      }, 500);

      // Trigger search after form data is processed
      setTimeout(() => {
        this.searchVehicles();
      }, 1000);
    }
  }



  processVehicleData() {
    if (this.searchVehicleData && Array.isArray(this.searchVehicleData) && this.searchVehicleData.length > 0) {
      this.packages = this.searchVehicleData.map((vehicle: any) => ({
        vehicleName: vehicle.vehicleName || '',
        vehicleType: vehicle.vehicleType || '',
        vehicleImage: vehicle.vehicleImage || 'assets/home-bg-car-image.png',
        packageName: vehicle.packageName || '',
        seatingCapacity: vehicle.seatingCapacity || 4,
        basicKM: vehicle.basicKM || 0,
        basicHrs: vehicle.basicHrs || 0,
        extraPerKm: vehicle.extraPerKm || 0,
        extraHrs: vehicle.extraHrs || 0,
        parkingIncExc: vehicle.parkingIncExc || '',
        tollIncExc: vehicle.tollIncExc || '',
        totalFare: vehicle.totalFare || 0,
        b2CTermsAndConditions: vehicle.b2CTermsAndConditions || '',
        noOfBags: vehicle.noOfBags || 0,
        noOfDays: vehicle.noOfDays || 0,
        toatlTaxAmt: vehicle.toatlTaxAmt || 0,
        packageAmount: vehicle.packageAmount || 0,
        ratePerkm: vehicle.ratePerkm || 0,
        packageKm: vehicle.packageKm || 0,
        cgst: vehicle.cgst || 0,
        sgst: vehicle.sgst || 0,
        igst: vehicle.igst || 0,
        cgstAmount: vehicle.cgstAmount || 0,
        sgstAmount: vehicle.sgstAmount || 0,
        nightCharges: vehicle.nightCharges || 0,
        driverAllowance: vehicle.driverAllowance || 0,
        isPerBookingAmt: vehicle.isPerBookingAmt || 0,
        poDetailsId: vehicle.poDetailsId || 0,
        isShowPerAmt: vehicle.isShowPerAmt || false,

      }));

      // Use NgZone to prevent ExpressionChangedAfterItHasBeenCheckedError
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.cdr.detectChanges();
          });
        });
      });
    } else {
      this.packages = [];
      // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.isVisible = true;
        this.isSearchListVisible = false;
        this.cdr.detectChanges();
      });
    }
    // Initialize filteredPackages with all packages
    this.filteredPackages = [...this.packages];
  }

  /**
   * Manually trigger form population
   */
  private manuallyPopulateForm(): void {
    if (this.tripSearchFormComponent && this.searchFormData) {
      // Check if form is ready before populating
      if (this.tripSearchFormComponent.isFormReady()) {
        // Use the public method to populate the form
        this.tripSearchFormComponent.populateForm(this.searchFormData);

        // Trigger search after form population
        setTimeout(() => {
          this.searchVehicles();
        }, 1000);
      } else {
        // Retry after 1 second if form is not ready
        setTimeout(() => {
          this.manuallyPopulateForm();
        }, 1000);
      }
    }
  }

  // Add AfterViewInit to ensure ViewChild is available
  ngAfterViewInit() {
    // If we have form data but the component wasn't available before, try again
    if (this.searchFormData && this.tripSearchFormComponent) {
      this.manuallyPopulateForm();
    } else if (this.searchFormData && !this.tripSearchFormComponent) {
      // Retry after a short delay
      setTimeout(() => {
        this.ngAfterViewInit();
      }, 500);
    }
  }

  setTripType(type: 'outstation' | 'local' | 'airport') {
    this.tripType = type;
    this.selectedTripType = type;

    // If we have the trip search form component, trigger the trip type change
    // This will clear the form fields when manually changing tabs
    if (this.tripSearchFormComponent) {
      this.tripSearchFormComponent.onTripTypeChange(type);
    }
  }
  selectedTripType: 'local' | 'outstation' | 'airport' = 'local';

  // Get the ClientDetails
  GetClientDetails() {
    this.tripSearchService.loadClientDetails().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (clientDetails: any) => {
        this.clientId = clientDetails.clientId;

        // Now that we have client details, try to populate the form
        if (this.searchFormData) {
          setTimeout(() => {
            this.manuallyPopulateForm();
          }, 500);
        }
      },
      error: (error: any) => {
        console.error('BookingSearch: Failed to load client details:', error);
        this.snackbarService.openSnackBarError('Failed to load client details. Please try again.');
      }
    });
  }

  // Bind the City Name and City Id
  BindCityDropDown(clientId: number) {
    // Implementation for binding city dropdown
  }

  onCityChange(event: MatSelectChange) {
    // Implementation for city change
  }

  BindPackageType() {
    // Implementation for binding package types
  }

  BindVehicleType() {
    // Implementation for binding vehicle types
  }

  // Search the Vehicle
  SearchCab() {
    const cityValue = this.form.controls['city'].value;
    const pickupTimeValue = this.form.controls['pickupTime'].value;

    if (!cityValue || !pickupTimeValue) {
      return;
    }
  }

  showForm = false;
  openMobileFilter() {
    // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.isVisible = true;
      this.isSearchListVisible = false;
      this.cdr.detectChanges();
    });
  }

  closeMobileFilter() {
    // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.isVisible = false;
      this.isSearchListVisible = true;
      this.cdr.detectChanges();
    });
  }

  goBack() {
    // Use setTimeout to defer the update to prevent ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.isVisible = false;
      this.cdr.detectChanges();
    });
  }

  getMarginTop(): string {
    if (this.isMobile && this.isVisible) {
      return '11px';
    } else if (this.isMobile) {
      return '68px';
    } else if (!this.isMobile && !this.isVisible) {
      return '75px';
    } else if (!this.isMobile && this.isVisible && this.isCheckhandshake) {
      return '0px';
    } else {
      return '78px';
    }
  }

  showLoginFormOnHome() {
    // Implementation for showing login form
  }

  onTabChange(tab: string) {
    this.selectedTab = tab;
  }

  /**
   * Search for vehicles based on form data using API
   */
  searchVehicles(): void {
    const searchParams = this.buildPackageDetailsSearchRequest();
    if (!searchParams) {
      return;
    }

    this.setLoading(true);
    this.tripSearchService.fetchPackageDetailsList(searchParams).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (data: any[]) => {
        this.tripSearchService.setSearchVehicleData(data);
        this.searchVehicleData = data;
        this.processVehicleData();
        this.setLoading(false);
      },
      error: () => {
        this.setLoading(false);
        this.snackbarService.openSnackBarError('Failed to reload search results. Please try Explore Cabs again.');
      }
    });
  }

  /** Matches trip-search-form onSearch → SearchVehicleOrPackageNew with searchFor PACKAGEDETAILS. */
  private buildPackageDetailsSearchRequest(): SearchRequest | null {
    if (!this.searchFormData || this.clientId == null) {
      return null;
    }

    const tripType = this.searchFormData.tripType || this.selectedTripType || this.tripType;
    const packageTypeId = tripType === 'local' ? 1 : tripType === 'outstation' ? 2 : 3;

    const startRaw = this.searchFormData.startDate;
    const endRaw = this.searchFormData.endDate || this.searchFormData.startDate;
    if (!startRaw) {
      return null;
    }

    const fromDate = startRaw instanceof Date ? startRaw : new Date(startRaw);
    const toDate = endRaw instanceof Date ? endRaw : new Date(endRaw);

    return {
      clientId: this.clientId,
      searchFor: 'PACKAGEDETAILS',
      vehicleTypeId: this.searchFormData.vehicleTypeId === '0' ? 0 : Number(this.searchFormData.vehicleTypeId) || 0,
      packageId: Number(this.searchFormData.selectPackageType) || 0,
      fromDate: this.dateUtilityService.formatDateForAPI(fromDate),
      toDate: this.dateUtilityService.formatDateForAPI(toDate),
      cityId: Number(this.searchFormData.cityId) || undefined,
      packageTypeId,
      pickupTime: this.searchFormData.pickupTime
    };
  }

  /**
   * Manually trigger API calls for the trip search form
   */
  public triggerFormApiCalls(): void {
    if (this.tripSearchFormComponent) {
      this.tripSearchFormComponent.reloadVehicleData();
    }
  }

  /**
   * Navigate to booking details page with selected package
   */
  bookNow(packageData: any): void {
    // Check if user is logged in
    if (!this.authService.isUserLoggedIn()) {
      this.pendingBookingPackage = packageData;
      this.showLoginModal = true;
      this.authService.showLoginForm();
      this.router.navigate(['/']);

      return;
    }

    // User is logged in, proceed with booking
    this.proceedWithBooking(packageData);
  }

  /**
   * Proceed with booking after login verification
   */
  private proceedWithBooking(packageData: any): void {
    // Store only the selected package data for the booking details page
    // without affecting the full search results
    this.tripSearchService.setSelectedPackage(packageData);

    // Navigate to booking details page
    this.router.navigate(['/booking-details']);
  }

  /**
   * Handle successful login
   */
  onLoginSuccess(): void {
    this.showLoginModal = false;

    // If there's a pending booking, proceed with it
    if (this.pendingBookingPackage) {
      this.proceedWithBooking(this.pendingBookingPackage);
      this.pendingBookingPackage = null;
    }
  }

  /**
   * Close login modal
   */
  closeLoginModal(): void {
    this.showLoginModal = false;
    this.pendingBookingPackage = null;
  }

  /**
   * Show estimate total modal for selected package
   */
  showEstimateTotal(packageData: any): void {
    this.selectedPackage = packageData;
    this.showEstimateModal = true;
  }

  /**
   * Close estimate total modal
   */
  closeEstimateModal(): void {
    this.showEstimateModal = false;
    this.selectedPackage = null;
  }

  /**
   * Proceed to booking from estimate modal
   */
  // proceedToBooking(): void {
  //   if (this.selectedPackage) {
  //     this.closeEstimateModal();
  //     this.bookNow(this.selectedPackage);
  //   }
  // }

  /**
   * Set loading state
   */
  private setLoading(loading: boolean): void {
    this.isLoading = loading;
  }

  /**
   * Cleanup on destroy
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Navigation methods for policy links
  navigateToTerms() {
    this.router.navigate(['/terms']);
  }

  navigateToConditions() {
    this.router.navigate(['/terms']);
  }
  // Handle info icon click for mobile devices
  showVehicleInfo(event: Event, info: string): void {
    if (this.isMobile) {
      event.preventDefault();
      event.stopPropagation();
      this.snackbarService.openSnackBarInfo(info);
    }
  }
}
